// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22bad1f0","453":"7342a22f","455":"1b88f6a7","977":"69d3e85f"}[chunkId] + ".chunk.js";
};